module.exports = __webpack_public_path__ + "img/rascrut-6.a03e2d4e.webp";